@if (slider$()?.title || slider$()?.intro) {
  <div class="mb-3 mb-md-4 text-max-width-sm">
    @if (!slider$()?.hideTitle && slider$()?.title; as title) {
      <h2 class="mb-0">{{ title }}</h2>
    }
    <!--@if (slider$()?.intro; as intro) {
      <p class="mb-0 mt-2">{{ intro }}</p>
    }-->
  </div>
}

<div class="content-slider">
  <div class="content-slider__arrow-trigger"></div>
  @if (loading$()) {
    <section class="text-center text-max-width-sm mx-auto my-5">
      <app-loading-indicator class="text-secondary" [loading]="true" [type]="'standalone'" />

      <p class="mb-0 mt-3 text-body-secondary fs-body-sm fw-normal">{{ 'content-slider-laden-tekst' | fromDictionary }}</p>
    </section>
  }
  <div class="embla-container-wrapper">
    <div class="embla-container" (mousewheel)="preventBack($event)">
      <app-embla-slider
        #slider
        [slides]="slider$()?.slides || []"
        [showDots]="false"
        [showArrows]="false"
        class="embla"
        [ngClass]="'slide-count-' + (slider$()?.slides?.length || 0)"
        [options]="{ dragFree: false, skipSnaps: true }"
      >
        <!--[navButtonClasses]="'button button-icon button--accent button--xl'"-->
        @for (slide of slider$()?.slides; track $index; let i = $index) {
          <div class="embla-slide content-slide" #swipeslide (click)="openModal($index)">
            <img
              class="content-slide__image"
              [class.cursor-pointer]="hasDialog()"
              [ngSrc]="slide.url || 'https://coda.fstr.io/media/placeholder.png'"
              [width]="1200"
              [height]="1200"
              [alt]="slide?.alt || slide?.caption"
              ngSrcset="550w, 800w, 1600w"
              [loaderParams]="{
                width: 1200,
                height: 1200,
                anchor: slide?.anchor || 'middlecenter',
                scale: 'both',
              }"
              [attr.data-object-position]="slide?.anchor || 'middlecenter'"
              [priority]="true"
              [sizes]="`
                (min-width: 768px) 25vw,
                (min-width: 576px) 50vw,
                100vw`"
              [loaderParams]="{ scale: 'both', mode: 'max', width: 1200, height: 1200 }"
            />

            @if (slide.caption) {
              <div class="content-slide__caption">
                <p class="caption max-lines-2 mb-1">
                  {{ slide.caption | stripHtml }}
                </p>
                @if (hasDialog()) {
                  <span class="button button-link button-xxs button--primary h-auto border-0 d-md-none">
                    {{ 'slider-open-details' | fromDictionary }}
                  </span>
                }
              </div>
            }

            @if (hasDialog()) {
              <span class="chip chip--primary chip--lg content-slide__chip d-none d-md-flex pointer-events-none">
                <fstr-icon anchor="line-icon-eye" />
              </span>
            }
          </div>
        }
      </app-embla-slider>
    </div>

    @if (slider.canScrollPrev()) {
      <button class="button button-icon button--accent button--xl embla-nav-pos embla-nav-pos--prev" (click)="slider.prev()">
        <fstr-icon anchor="line-icon-arrow-left" />
        <span class="sr-only">Vorige</span>
      </button>
    }
    @if (slider.canScrollNext()) {
      <button class="button button-icon button--accent button--xl embla-nav-pos embla-nav-pos--next" (click)="slider.next()">
        <fstr-icon anchor="line-icon-arrow-right" />
        <span class="sr-only">Volgende</span>
      </button>
    }

    <!--@if (!embla()?.isBeginning) {
      <button class="button button-icon button--accent button--xl embla-button-prev bg-accent" (click)="embla()?.slidePrev()">
        <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
        <span class="sr-only">Vorige</span>
      </button>
    }

    @if (!isEnd) {
      <button class="button button-icon button--accent button--xl embla-button-next bg-accent" (click)="embla()?.slideNext()">
        <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
        <span class="sr-only">Volgende</span>
      </button>
    }-->
  </div>
</div>
